<template>
  <div>
    <v-app-bar flat app dark color="primary">
      <v-app-bar-nav-icon
        @click.native.stop="updateUILeftDrawerState(!UILeftDrawer)"
        v-if="!screenIsWideEnough"
      ></v-app-bar-nav-icon>
      <v-icon v-else>fad fa-user-chart</v-icon>
      <v-toolbar-title v-if="UserHasRole('Broker')" class="ml-0 pl-3">Account settings</v-toolbar-title>
      <v-toolbar-title v-else class="ml-0 pl-3">Brokers</v-toolbar-title>
      <v-layout align-center style="max-width: 800px" v-if="UserHasRole('Platform')">
        <v-autocomplete
          :items="BrokersList"
          item-text="name"
          item-value="id"
          label="Select a broker"
          solo-inverted
          flat
          dense
          class="ml-5"
          v-if="!screenIsWideEnough"
        ></v-autocomplete>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn color="accent" dark fab absolute bottom right @click="showDialog = true" v-if="UserHasRole('Platform')">
        <v-icon>add</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <v-container fill-height fluid class="pa-0 calc-height grey lighten-2">
        <v-layout :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }">
          <v-flex v-if="UserHasRole('Platform')" class="list-container" :class="{ hidden: !screenIsWideEnough }">
            <v-list class="pt-0" two-line dense v-if="BrokersList">
              <template v-for="broker in BrokersList">
                <v-list-item
                  :key="`broker-${broker.id}`"
                  @click="selectBroker(broker.id)"
                  :class="{ selected: broker.id === selected.id, disabled: !broker.enabled }"
                >
                  <v-list-item-content>
                    <v-list-item-title style="max-width:250px;overflow: hidden;text-overflow: ellipsis">{{
                      broker.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle>{{ broker.contact }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider :key="`broker-divider-${broker.id}`"></v-divider>
                <template v-for="child in broker.children">
                  <v-list-item
                    :class="{ selected: child.id === selected.id, disabled: !child.enabled }"
                    :key="`child-${child.id}`"
                    @click="selectBroker(child.id)"
                    class="child"
                  >
                    <v-list-item-content class="px-4">
                      <v-list-item-title style="max-width:250px;overflow: hidden;text-overflow: ellipsis">{{
                        child.name
                      }}</v-list-item-title>
                      <v-list-item-subtitle>{{ child.contact }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider :key="`child-divider-${child.id}`"></v-divider>
                </template>
              </template>
            </v-list>
          </v-flex>
          <v-flex>
            <v-card
              flat
              class="transparent"
              :class="{ 'ml-0': $vuetify.breakpoint.width <= 1600, 'ml-4': $vuetify.breakpoint.width > 1600 }"
            >
              <v-tabs background-color="grey lighten-3" v-model="tabs">
                <v-tabs-slider color="accent"></v-tabs-slider>
                <v-tab @click="showRightDrawer = false">Details</v-tab>
                <v-tab @click="showRightDrawer = false">Users</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tabs">
                <v-tab-item>
                  <broker-details></broker-details>
                </v-tab-item>
                <v-tab-item>
                  <broker-users></broker-users>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <new-broker-dialog :show.sync="showDialog"></new-broker-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import NewBrokerDialog from './NewBrokerDialog';
import BrokerDetails from './BrokerDetails';
import BrokerUsers from './BrokerUsers';

export default {
  components: {
    BrokerUsers,
    BrokerDetails,
    NewBrokerDialog
  },
  name: 'brokers',
  data: () => ({
    tabs: null,
    fab: false,
    search: null,
    showDialog: false,
    showRightDrawer: false,
    broker: {
      id: null
    }
  }),
  computed: {
    ...mapGetters(['BrokersList', 'SelectedBroker', 'RegistrationReferrerList', 'UserHasRole', 'UILeftDrawer']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    },
    selected: {
      get() {
        return this.broker;
      },
      set(id) {
        this.broker = this.selectBroker(id);
      }
    }
  },
  methods: {
    ...mapActions([
      'getBrokersList',
      'selectBroker',
      'setBrokerSearch',
      'getRegistrationReferrerList',
      'updateUILeftDrawerState'
    ]),
    clearSearch() {
      this.search = '';
      this.setBrokerSearch('').then(() => this.getBrokersList());
    },
    setSearch: function() {
      this.setBrokerSearch(this.search).then(() => this.getBrokersList());
    }
  },
  mounted() {
    this.getBrokersList();
    if (this.RegistrationReferrerList.length === 0) {
      this.getRegistrationReferrerList();
    }
  },
  watch: {
    SelectedBroker: function(broker) {
      this.broker = _.clone(broker);
    }
  }
};
</script>

<style lang="scss" scoped>
.full-height {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-height {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.calc-filtered-height {
  height: calc(100vh - 267px);
  max-height: calc(100vh - 267px);
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
}

.responsive {
  width: 100%;
  max-width: 135px;
  height: auto;
}

.child {
  background: #ddd;
}
.selected {
  background: #b08faf;
  color: white;

  .list__tile__title {
    font-weight: 600;
  }

  .list__tile__sub-title {
    color: rgba(255, 255, 255, 0.87);
  }
}

::v-deep {
  .input-group--text-field input,
  .input-group__selections__comma {
    font-size: 13px;
  }
}

::v-deep textarea {
  font-size: 13px;
}

td {
  /*padding-left: 15px;*/
  button {
    margin: 0;
    max-width: 250px;
    width: 250px;
  }

  ::v-deep .btn,
  ::v-deep .btn__content {
    width: 250px;
    max-width: 250px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    justify-content: start;
    text-align: left;
    display: inline;
    padding: 0;
  }
}

::v-deep th:nth-child(n + 2):nth-last-child(n + 2),
td:nth-child(n + 2):nth-last-child(n + 2) {
  /*padding: 0 24px 0 0;*/
}

::v-deep th:last-child,
td:last-child {
  padding: 0 24px 0 0 !important;
}

.theme--light .input-group.input-group--solo-inverted.input-group--focused {
  background-color: #fff;
  ::v-deep input,
  ::v-deep .input-group__prepend-icon {
    color: rgba(0, 0, 0, 0.78);
  }
}

.btn-toggle--selected {
  box-shadow: none;
  .btn--active {
    color: #e91e63;
    > .btn__content:before {
      opacity: 0;
    }
  }
}

.hidden {
  display: none;
}

::v-deep .disabled {
  color: rgba(0, 0, 0, 0.54);
  text-decoration: line-through;
}

.theme--light {
  .subheader.text--accent-1 {
    color: #e91e63;
  }
  &.v-list {
    background: inherit;
  }
}

::v-deep .tabs__item--active {
  color: #2196f3;
}

::v-deep .v-list__tile.v-list__tile--link.theme--light {
  border-radius: 0 !important;
}

.list-container {
  border-right: 1px solid #ddd;
  max-width: 280px;
  min-width: 280px;
  overflow-y: auto;
  width: 280px;
}
</style>
